import { Column } from 'react-table';
import { AntdColumn, AntdTableSort, ReactTableSort, SortOption } from '../../types/common/table';

export const getTablePages = (totalCnt: number, pageSize?: number): number => {
  if (!pageSize) return 0;
  return Math.ceil(totalCnt / pageSize);
};

export const changeTableSortToReactTableSort = (sort: SortOption): { id: string; desc: boolean }[] => {
  return Object.entries(sort).map(([name, isDesc]) => ({ id: name, desc: isDesc }));
};

export const changeReactTableSortToTableSort = (sort: ReactTableSort): SortOption => {
  return sort.reduce(
    (prev, curr) => ({
      ...prev,
      [curr.id]: curr.desc,
    }),
    {},
  );
};

export const changeAntdSortToTableSort = (sort: AntdTableSort): SortOption => {
  return Object.entries(sort).reduce((prev, curr) => {
    const [key, status] = curr;
    return { ...prev, [key]: status === 'descend' };
  }, {});
};

export const changeTableSortToAntdSort = (sort: SortOption): AntdTableSort => {
  return Object.entries(sort).reduce((prev, curr) => {
    const [key, isDesc] = curr;
    return { ...prev, [key]: isDesc ? 'descend' : 'ascend' };
  }, {});
};

export const antdTableSimpleColumns = <Item>(targetColumns: AntdColumn<Item>[]): AntdColumn<Item>[] => {
  return targetColumns.map((column) => {
    const { sortOrder, sorter, filterable, filterDropdown, ...simpleColumn } = column;
    return simpleColumn;
  });
};

export const reactTableSimpleColumns = <T>(targetColumns: Column<T>[]): Column<T>[] => {
  return targetColumns.map((column) => {
    const { sortable, filterable, Filter, ...simpleColumn } = column;
    return simpleColumn;
  });
};
